'use client';

import * as React from 'react';
import DeleteMediaItemContent from '@/app/dashboard/cms/file-storage/components/delete-media-item-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function DeleteMediaItemModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Delete Media" isOpen={modal?.open === ModalDrawer.DELETE_MEDIA_ITEM}>
      <DeleteMediaItemContent />
    </ModalLayout>
  );
}
